<nav class="navbar navbar-expand-lg navbar-light bg-faded">
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle d-lg-none float-left" data-toggle="collapse">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
    </div>
    <div class="navbar-container">
      <div id="navbarSupportedContent">
        <ul class="navbar-nav">
          <app-user-profile></app-user-profile>
        </ul>
      </div>
    </div>
  </div>
</nav>
